module.exports = __webpack_public_path__ + "static/media/sasai-money-transfer-logo.fa774165.png";